(function () {
  'use strict';

  function getNoteField() {
    return document.querySelector('[data-sgf-cart-note]') || document.getElementById('Cart-note');
  }

  function getProxyButton() {
    return document.querySelector('[data-sgf-cart-checkout-proxy]') || document.getElementById('custom-showRecommendationsBtn');
  }

  function getHiddenCheckoutButton() {
    return document.getElementById('wf-ld-checkout');
  }

  function bindNoteAutoSave() {
    var noteField = getNoteField();
    if (!noteField || noteField.__sgfCartNoteBound) return;
    noteField.__sgfCartNoteBound = true;

    var timer = null;

    function saveNote() {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ note: noteField.value }),
      }).catch(function () {});
    }

    noteField.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(saveNote, 800);
    });

    noteField.addEventListener('change', saveNote);
  }

  function syncCheckoutProxyState() {
    var proxyButton = getProxyButton();
    var hiddenCheckoutButton = getHiddenCheckoutButton();
    if (!proxyButton) return;

    proxyButton.disabled = !hiddenCheckoutButton || !!hiddenCheckoutButton.disabled;
  }

  function bindCheckoutProxy() {
    var proxyButton = getProxyButton();
    if (!proxyButton) return;

    if (!proxyButton.__sgfCartCheckoutProxyBound) {
      proxyButton.__sgfCartCheckoutProxyBound = true;
      proxyButton.addEventListener('click', function (event) {
        event.preventDefault();

        var hiddenCheckoutButton = getHiddenCheckoutButton();
        if (hiddenCheckoutButton && !hiddenCheckoutButton.disabled) {
          hiddenCheckoutButton.click();
        }
      });
    }

    syncCheckoutProxyState();
  }

  function init() {
    bindNoteAutoSave();
    bindCheckoutProxy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof document.addEventListener === 'function') {
    document.addEventListener('shopify:section:load', init);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(init, 0);
    });
  }
})();
